import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';

import {GetSizeSelectionResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/size_selection/v1/service.types';
import {useSizeReminderState} from '../../../features/SizeSelection/SizeSectionSizeReminder';
import {SoldOutSizeSelectionModal} from '../../../features/SizeSelection/SoldOutSizeSelection';
import {SizeSelectionOpenedStateKey} from '../../../features/SizeSelectionFlyout/hooks/useSizeSelectionOpenedState';
import {useGetSizeSelection} from '../../../shared-deprecated/useGetSizeSelection';
import {SoldOutSizeReminderFlyoutView} from '../../ArticleDetail/AddToBasketSection/SoldOutSizeReminderFlyoutView';

interface SizeSelectionViewProps {
  productId: number;
  withFlyout?: boolean;
  isOpenSizeReminder?: boolean;
  setIsOpenSizeReminder?: (value: boolean) => void;
}

const WishlistSizeReminderView = ({
  product,
  sizeSelection,
}: GetSizeSelectionResponse & SizeSelectionViewProps) => {
  const type = sizeSelection?.type;

  const {toggleSoldOutSizeId, sizeReminderSizeIds, resetSizeReminderSelection} =
    useSizeReminderState(
      type?.$case === 'oneSize' && type.oneSize.size
        ? [type.oneSize.size.sizeId]
        : [],
    );

  return (
    <SoldOutSizeSelectionModal
      renderInPortal={false}
      sizeSelection={sizeSelection}
      selectedSizeIds={sizeReminderSizeIds}
      onSizeSelect={toggleSoldOutSizeId}
      product={product}
      sizeReminderSizeIds={sizeReminderSizeIds}
      resetSizeSelection={resetSizeReminderSelection}
    />
  );
};

export const WishlistSizeReminder = (props: SizeSelectionViewProps) => {
  if (props.setIsOpenSizeReminder) {
    return <SoldOutDataFetcherFlyoutView {...props} />;
  }

  return <SoldOutDataFetcherModalView {...props} />;
};

// used on desktop
const SoldOutDataFetcherModalView = (props: SizeSelectionViewProps) => {
  return (
    <DataFetcher
      request={useGetSizeSelection({
        productId: props.productId,
        enableSizeFinder: true,
        isRequestDisabled: !props.productId,
      })}
      View={WishlistSizeReminderView}
      Error={null}
      Loading={() => null}
      viewProps={props}
    />
  );
};

// used on mobile
const SoldOutDataFetcherFlyoutView = (props: SizeSelectionViewProps) => {
  const request = useGetSizeSelection({
    productId: props.productId,
    enableSizeFinder: true,
    isRequestDisabled: !props.productId,
  });

  return (
    <DataFetcher
      request={request}
      View={SoldOutSizeReminderFlyoutView}
      Error={null}
      Loading={() => null}
      viewProps={{
        ...props,
        isOpenSizeReminder: Boolean(props.isOpenSizeReminder),
        setIsOpenSizeReminder: props.setIsOpenSizeReminder!,
        sizeSelectionStateManagerKey:
          SizeSelectionOpenedStateKey.NO_SIZE_SELECTED_SELECTION,
      }}
    />
  );
};
